export default __webpack_public_path__ + "static/media/IkonForvaltning.c6301d9f.svg";